<template>
  <div>
    <div v-bind="$attrs" class="relative" @click="showPopup = true">
      <div
        v-if="filterLength > 0"
        z="1" h="3" w="3" rounded="full" text="8px white center" leading="3"
        class="absolute right-0 bg-black leading-3 -top-1"
      >
        {{ filterLength }}
      </div>
      <div
        h="9" flex="~ 1 items-center" b="~ 1 solid #777474" rounded="full" bg="#F3F3F3" p="x-4"
        class="line-clamp-1"
      >
        <img w="4" src="~assets/icons/icon-huge.png" />
        <span class="ml-2 text-sm text-[#777474]">{{ t('key.list.filter') }}</span>
      </div>
    </div>
    <van-popup
      v-model:show="showPopup"
      position="bottom"
      class="az-search__popup"
      close-icon-position="top-left"
      closeable
      safe-area-inset-bottom
      close-on-popstate
      @closed="closeHandler"
    >
      <div class="h-full flex flex-col">
        <div class="py-2 pl-12" text="lg" font="700" border-b="1px #E4E4E4 solid">
          {{ t('key.experience.add.filters') }}
        </div>
        <div class="flex-1 overflow-y-auto" p="y-6 x-2">
          <div mb-9>
            <div class="px-4 pb-2 text-16px text-[#121212] font-500">
              {{ t('key.filter.booking.options') }}
            </div>
            <div>
              <BaseAZCheckBox
                v-model="freeCancellation"
                name="Free cancellation"
                icon-size="1.25rem"
                class="box-border w-full flex items-center px-4 py-1.5"
              >
                <span class="text-sm text-[#121212]" font="500">{{ t('key.experience.filter.free.cancellation') }}</span>
                <img w="4" h="4" :src="infoSvg" m="l-1" @click.stop="openPolicy" />
              </BaseAZCheckBox>
              <BaseAZCheckBox
                v-model="instantConfirmation"
                icon-size="1.25rem"
                name="Instant confirmation"
                class="box-border w-full flex items-center px-4 py-1.5"
              >
                <span class="text-sm text-[#121212]" font="500">{{ t('key.experience.filter.instant.confirmation') }}</span>
              </BaseAZCheckBox>
            </div>
          </div>
        </div>
        <div class="px-4 py-4">
          <van-button round block color="#000000" @click.stop="onConfirm">
            <span text="base">{{ t('key.business.select.ticket.apply') }}</span>
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script lang="ts" setup>
import infoSvg from '@/assets/info.svg'

const showPopup = ref(false)
const { filterParams, getExperienceDetail } = useExperienceDetail()

const freeCancellation = ref(filterParams.value.freeCancellation)
const instantConfirmation = ref(filterParams.value.instantConfirmation)

const { t } = useI18n()

function onConfirm() {
  filterParams.value.freeCancellation = freeCancellation.value
  filterParams.value.instantConfirmation = instantConfirmation.value
  getExperienceDetail()
  showPopup.value = false
}

function closeHandler() {
  freeCancellation.value = filterParams.value.freeCancellation
  instantConfirmation.value = filterParams.value.instantConfirmation
}

const filterLength = computed(() => {
  return (filterParams.value.freeCancellation ? 1 : 0) + (filterParams.value.instantConfirmation ? 1 : 0)
})

function openPolicy() {
  showDialog({
    showConfirmButton: false,
    closeOnClickOverlay: true,
    messageAlign: 'left',
    title: t('key.experience.cancellation.policy'),
    message: t('key.filter.cancellation.tooltip'),
  })
}
</script>

<style lang="scss" scoped>
.az-search__popup {
  height: 100%;
  :deep(.van-popup__close-icon) {
    top: 12px;
  }
}
</style>
